// Safely extract role names from user.role regardless of shape (array, object, string)
export const getRoleNames = (role: any): string[] => {
  if (!role) return [];
  if (Array.isArray(role)) return role.map((r: any) => (typeof r === 'string' ? r : r?.name || ''));
  if (typeof role === 'string') return [role];
  if (typeof role === 'object' && role.name) return [role.name];
  return [];
};

// Safely ensure role is an array (for cases where you need the full role objects, not just names)
export const ensureRoleArray = (role: any): any[] => {
  if (!role) return [];
  if (Array.isArray(role)) return role;
  return [role];
};
